var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"8","y":"2","width":"18.7059","height":"30","rx":"4","stroke":"black","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"12.2061","y":"1.5","width":"10.2941","height":"2.76471","rx":"1.38235","fill":"black","stroke":"black","key":1}),React.createElement("circle",{"cx":"17.3531","cy":"27.3529","r":"1.88235","fill":"#071BF5","key":2})]);
}

PhoneInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
